import { toastr } from "react-redux-toastr";
import { put } from "redux-saga/effects";
import features from "features";

const errors = {
  UNKNOWN_ERROR: 0,
  EXPIRED_TOKEN: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  FORM_ERROR: 422,
  BAD_REQUEST: 400,
  MANY_ATTEMPTS: 429
};

export function* setRequestError(response) {
  const status = (response && response.status) || null;

  switch (status) {
    case errors.NOT_FOUND:
      return;
    case errors.BAD_REQUEST:
      toastr.error(`Error`, `${response.data.message}`);
      return;
    case errors.MANY_ATTEMPTS:
      toastr.error(`Error`, `Too many attempts, try again in a few minutes`);
      return;
    case errors.EXPIRED_TOKEN:
      yield put(features.auth.actions.signOutRequest());
      return;
    case errors.FORBIDDEN:
      toastr.error(`Forbidden`, `${response.data.message}`);
      return;
    default: {
      toastr.error(`Error`, `Something went wrong. Try again later.`);
    }
  }
}
